import { useRef, useState } from 'react';

export const useSyndicationFilters = () => {
  const [userFilteredChannels, setUserFilteredChannels] = useState([]);

  const filteredPropertyIdsRef = useRef([]);

  return {
    filteredPropertyIdsRef,
    setUserFilteredChannels,
    userFilteredChannels,
  };
};
